import { render, staticRenderFns } from "./ListDriverCompaniesPage.vue?vue&type=template&id=6f28a53c"
import script from "./ListDriverCompaniesPage.vue?vue&type=script&lang=js"
export * from "./ListDriverCompaniesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports